<template>
  <div class="detail-wrap">
    <div class="del-top">
      <div
        class="func"
        :class="
          organDetails.functional_status < -20
            ? 'blue'
            : organDetails.functional_status > 20
            ? 'orange'
            : 'green'
        "
        :style="{ left: funcLeft + '%' }"
      >
        <div>
          功能值：<span>{{ organDetails.functional_status }}</span>
        </div>
        <div>({{ organDetails.functional_status_level }})</div>
      </div>
      <div
        class="trans"
        :class="
          organDetails.transition < -20
            ? 'blue'
            : organDetails.transition > 20
            ? 'orange'
            : 'green'
        "
        :style="{ left: transLeft + '%' }"
      >
        <div>
          修复值： <span>{{ organDetails.transition }}</span>
        </div>
        <div>({{ organDetails.transition_level }})</div>
      </div>
      <div class="del-bar">
        <div class="left">
          <span>-100</span>
          <span>-20</span>
        </div>
        <div class="center"></div>
        <div class="right">
          <span>20</span>
          <span>100</span>
        </div>
      </div>
    </div>
    <div class="remarks">
      <div class="title">{{ organDetails.name }}养护</div>
      <div class="desc">
        <div v-for="(item, index) in details.remakrs" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TableDetail",
  props: {
    details: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  watch: {
    details: {
      handler (newVal) {
        this.organDetails = newVal
        this.funcLeft = this.handleLeft('functional_status')
        this.transLeft = this.handleLeft('transition')
      },
      deep: true
    },
  },
  data () {
    return {
      organDetails: {},
      funcLeft: 0,
      transLeft: 0
    };
  },
  created () {
    this.organDetails = this.details
    this.funcLeft = this.handleLeft('functional_status')
    this.transLeft = this.handleLeft('transition')
  },
  methods: {
    handleLeft (type) {
      let left = 0
      if (this.details[type] > 0) {
        left = (Number((this.organDetails[type] / 200).toFixed(3)) + 0.5) * 100;
      } else if (this.details[type] < 0) {
        left = (0.5 - Number((-this.organDetails[type] / 200).toFixed(3))) * 100;
      } else {
        left = 50;
      }
      return left
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-wrap {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 20px 0;
}
.del-top {
  position: relative;
  height: 290px;
  width: 600px;
  margin: 10px auto 30px;
  .func {
    position: absolute;
    top: 0;
    margin-left: -72px;
    &::after {
      content: "";
      position: absolute;
      bottom: -60px;
      width: 4px;
      height: 60px;
    }
  }
  .trans {
    position: absolute;
    bottom: 0;
    margin-left: -72px;
    &::after {
      content: "";
      position: absolute;
      top: -60px;
      width: 4px;
      height: 60px;
    }
  }
  .blue {
    span {
      color: #41b2ff;
    }
    div {
      &:last-child {
        color: #41b2ff;
      }
    }
    &::after {
      background-color: #41b2ff;
    }
  }
  .green {
    span {
      color: #20c384;
    }
    div {
      &:last-child {
        color: #20c384;
      }
    }
    &::after {
      background-color: #20c384;
    }
  }
  .orange {
    span {
      color: #f99c3f;
    }
    div {
      &:last-child {
        color: #f99c3f;
      }
    }
    &::after {
      background-color: #f99c3f;
    }
  }
  .del-bar {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 600px;
    margin: auto;
    border-radius: 3px;
    // overflow: hidden;
    height: 20px;
    display: flex;
    .left {
      position: relative;
      width: 40%;
      height: 100%;
      background-color: #41b2ff;
      display: flex;
      justify-content: space-between;
      span {
        position: absolute;
        bottom: -40px;
        font-size: 24px;
        &:first-child {
          left: -24px;
        }
        &:last-child {
          right: -16px;
        }
      }
    }
    .center {
      width: 20%;
      height: 100%;
      background-color: #20c384;
    }
    .right {
      position: relative;
      width: 40%;
      height: 100%;
      background-color: #f99c3f;
      display: flex;
      justify-content: space-between;
      span {
        position: absolute;
        bottom: -40px;
        font-size: 24px;
        &:first-child {
          left: -20px;
        }
        &:last-child {
          right: -16px;
        }
      }
    }
  }
}
.remarks {
  padding: 10px;
  width: 600px;
  margin: auto;
  color: #616161;
  line-height: 36px;
  text-align: left;
  .title {
    padding: 5px;
    border-left: 8px solid #20c384;
    font-size: 32px;
  }
  .desc {
    padding: 10px 0;
    font-size: 32px;
    text-align: left;
    div {
      position: relative;
      margin-left: 20px;
      margin-bottom: 15px;
      &::after {
        content: "";
        position: absolute;
        top: 12px;
        left: -20px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #20c384;
      }
    }
  }
}
</style>